/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ContentWatchSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ContentWatchSettings model module.
   * @module model/ContentWatchSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ContentWatchSettings</code>.
   * @alias module:model/ContentWatchSettings
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>ContentWatchSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ContentWatchSettings} obj Optional instance to populate.
   * @return {module:model/ContentWatchSettings} The populated <code>ContentWatchSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'String');
      }
      if (data.hasOwnProperty('WatchID')) {
        obj['WatchID'] = ApiClient.convertToType(data['WatchID'], 'Integer');
      }
      if (data.hasOwnProperty('Type')) {
        obj['Type'] = ApiClient.convertToType(data['Type'], 'Integer');
      }
      if (data.hasOwnProperty('TargetURI')) {
        obj['TargetURI'] = ApiClient.convertToType(data['TargetURI'], 'String');
      }
      if (data.hasOwnProperty('Selector')) {
        obj['Selector'] = ApiClient.convertToType(data['Selector'], 'String');
      }
      if (data.hasOwnProperty('LastFetchTime')) {
        obj['LastFetchTime'] = ApiClient.convertToType(data['LastFetchTime'], 'Date');
      }
      if (data.hasOwnProperty('SnapshotURI')) {
        obj['SnapshotURI'] = ApiClient.convertToType(data['SnapshotURI'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ModeratorID')) {
        obj['ModeratorID'] = ApiClient.convertToType(data['ModeratorID'], 'Integer');
      }
      if (data.hasOwnProperty('SWOTTopicID')) {
        obj['SWOTTopicID'] = ApiClient.convertToType(data['SWOTTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('PersonalTopicID')) {
        obj['PersonalTopicID'] = ApiClient.convertToType(data['PersonalTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('TrendTopicID')) {
        obj['TrendTopicID'] = ApiClient.convertToType(data['TrendTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('StakeholderID')) {
        obj['StakeholderID'] = ApiClient.convertToType(data['StakeholderID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('PESTELAreaID')) {
        obj['PESTELAreaID'] = ApiClient.convertToType(data['PESTELAreaID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} ID
   * @default ''
   */
  exports.prototype['ID'] = '';
  /**
   * @member {Integer} WatchID
   * @default 0
   */
  exports.prototype['WatchID'] = 0;
  /**
   * @member {Integer} Type
   * @default 0
   */
  exports.prototype['Type'] = 0;
  /**
   * @member {String} TargetURI
   * @default ''
   */
  exports.prototype['TargetURI'] = '';
  /**
   * @member {String} Selector
   * @default ''
   */
  exports.prototype['Selector'] = '';
  /**
   * @member {Date} LastFetchTime
   */
  exports.prototype['LastFetchTime'] = undefined;
  /**
   * @member {String} SnapshotURI
   * @default ''
   */
  exports.prototype['SnapshotURI'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} ModeratorID
   * @default 0
   */
  exports.prototype['ModeratorID'] = 0;
  /**
   * @member {Integer} SWOTTopicID
   */
  exports.prototype['SWOTTopicID'] = undefined;
  /**
   * @member {Integer} PersonalTopicID
   */
  exports.prototype['PersonalTopicID'] = undefined;
  /**
   * @member {Integer} TrendTopicID
   */
  exports.prototype['TrendTopicID'] = undefined;
  /**
   * @member {Integer} StakeholderID
   */
  exports.prototype['StakeholderID'] = undefined;
  /**
   * @member {Integer} CompanyLegalEntityID
   */
  exports.prototype['CompanyLegalEntityID'] = undefined;
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;
  /**
   * @member {Integer} PESTELAreaID
   */
  exports.prototype['PESTELAreaID'] = undefined;



  return exports;
}));


